import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") return setStatus("paid");
        if (["expired", "failed"].includes(data.payment_status)) return setStatus("error");
      } catch (err) { console.error("Payment status check failed, will retry:", err); }
      if (++tries < 10) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FBFBFA] p-6">
      <div className="max-w-md w-full rounded-2xl border border-slate-200 bg-white p-10 text-center" data-testid="payment-success-page">
        {status === "checking" && (<><Loader2 className="h-12 w-12 animate-spin text-[#595C2B] mx-auto" /><p className="mt-4 text-slate-600">Confirming your payment...</p></>)}
        {status === "paid" && (<>
          <CheckCircle2 className="h-14 w-14 text-emerald-500 mx-auto" />
          <h1 className="font-display text-3xl font-bold text-[#595C2B] mt-4">Lesson confirmed!</h1>
          <p className="text-slate-500 mt-2">Your payment was successful. The Google Meet link is now available in your dashboard.</p>
          <Button onClick={() => navigate("/dashboard/parent")} className="mt-6 rounded-full bg-[#595C2B] hover:bg-[#45481F] text-white btn-lift" data-testid="go-dashboard-btn">Go to dashboard</Button>
        </>)}
        {["error", "timeout"].includes(status) && (<>
          <XCircle className="h-14 w-14 text-amber-500 mx-auto" />
          <h1 className="font-display text-2xl font-bold text-[#595C2B] mt-4">Still processing</h1>
          <p className="text-slate-500 mt-2">We couldn't confirm the payment yet. Check your dashboard shortly.</p>
          <Button onClick={() => navigate("/dashboard/parent")} className="mt-6 rounded-full bg-[#595C2B] text-white">Go to dashboard</Button>
        </>)}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FBFBFA] p-6">
      <div className="max-w-md w-full rounded-2xl border border-slate-200 bg-white p-10 text-center" data-testid="payment-cancel-page">
        <XCircle className="h-14 w-14 text-slate-400 mx-auto" />
        <h1 className="font-display text-2xl font-bold text-[#595C2B] mt-4">Payment cancelled</h1>
        <p className="text-slate-500 mt-2">No charge was made. You can try booking again anytime.</p>
        <Link to="/dashboard/parent"><Button className="mt-6 rounded-full bg-[#595C2B] hover:bg-[#45481F] text-white">Back to dashboard</Button></Link>
      </div>
    </div>
  );
}
